<template>
  <div class="import-stu">
    <h3>合同批量导入</h3>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>操作提示</span>
        <el-button style="float: right;" @click="handleDownload" type="primary"
          >下载模板</el-button
        >
      </div>
      <h3>
        先下载模板，并按照要求录入合同数据「请勿随意更改模板内容」
      </h3>
      <p style="margin-top: 10px; color: #666;">
        必填字段：项目名称、服务内容（请填写服务内容管理中的名称）、建设单位、承接单位（请填写单位名称缩写，详见承接单位管理）、截止时间
      </p>
    </el-card>

    <el-divider></el-divider>
    <el-upload
      ref="upload"
      class="upload-card"
      :limit="1"
      action="#"
      drag
      :http-request="uploadFile"
      list-type="text"
      accept=".xls"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将表格拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">
        只能上传模板表格（.xls格式）
      </div>
    </el-upload>
  </div>
</template>

<script>
import {
  getHetongTemplate,
  uploadHetongTemplate,
} from "../api";
export default {
  name: "ImportStu",
  components: {},
  computed: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    //处理下载模板表格
    handleDownload() {
      getHetongTemplate()
        .then((res) => {
          const blob = new Blob([res.data]);
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          downloadElement.download = decodeURIComponent("合同导入模板.xls");
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
          this.$message.success("模板下载成功");
        })
        .catch((failResponse) => {
          this.$message.error("模板下载失败");
        });
    },
    // 文件上传
    uploadFile(params) {
      let _this = this;
      const _file = params.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      uploadHetongTemplate(formData)
        .then((res) => {
          if (res.code === 0) {
            _this.$notify({
              title: "导入成功",
              message: res.msg,
              type: "success",
              duration: 3000
            });
          } else {
            _this.$notify.error({
              title: "导入失败",
              message: res.msg,
              duration: 5000
            });
          }
          _this.$refs.upload.clearFiles();
        })
        .catch((failResponse) => {
          _this.$notify.error({
            title: "导入失败",
            message: "上传失败，请检查文件格式",
            duration: 5000
          });
          _this.$refs.upload.clearFiles();
        });
    },
  },
};
</script>

<style>
.head-title{
  font-size: 16px;
  font-weight: bold;
}
.upload-card .el-upload-dragger {
  width: 100% !important;
}
.upload-card .el-upload {
  width: 100%;
}
</style>
